import _ from 'lodash';

const initialState = {
    wager: {
        str: 1,
        num: '1',
        error: undefined
    },
    payout: {
        str: 2.00,
        num: '2.00',
        error: undefined
    },
    nextHash: undefined
}

function updateWager(newWager) {
    initialState.wager = _.merge({}, initialState.wager, newWager);

    let n = parseInt(initialState.wager.str, 10);

    if(isFinite(n)) {
    n = Math.max(1, n);
     initialState.wager.str = n.toString();
    }
    if(isNaN(n) || /[^\d]/.test(n.toString())) {
        initialState.wager.error = 'INVALID_WAGER';
    } else if (initialState.wager.str * 100 > this.props.balances ) {
        initialState.wager.error = 'CANNOT_AFFORD_WAGER';
    } else {
        initialState.wager.error = null;
        initialState.wager.str = n.toString();
        initialState.wager.num = n;
    }
}

function validatePayout(newStr) {

    const num = parseFloat(newStr, 10);

    const isFloatRegexp = /^(\d*\.)?\d+$/;

    if(isNaN(num) || !isFloatRegexp.test(newStr)) {
        initialState.payout.error = 'INVALID_PAYOUT';
    } else if(num < 1.01) {
        initialState.payout.error = 'PAYOUT_TOO_LOW';
    } else if(num > 9900) {
        initialState.payout.error = 'PAYOUT_TOO_HIGH'
    } else {
        initialState.payout.num = num;
        initialState.payout.error = null;
    }
    updatePayout(newStr);
}

function updatePayout(newPayout) {
    initialState.payout = _.merge(initialState.payout, newPayout);
}

function setNextHash(hexString) {
    initialState.nextHash = hexString;
}

const messages = {
    'CANNOT_AFFORD_WAGER': 'Lower bet or make deposit.',
    'INVALID_WAGER': 'Bet is invalid.'
}

function translateErrors () {
   let Err =  initialState.wager.error || initialState.payout.error;
   Err ? Err[messages] : '';
}


export default function bet(state=initialState, action) {
    switch(action.type){
        case 'SET_NEXT_HASH':
         return {
            state,
            nextHash: setNextHash
        };
        case 'UPDATE_WAGER':
         return {
            ...state, 
            wager: updateWager       
        };
        case 'ERROR_WAGER':
         return {
             ...state,
             wager: {
                 error: translateErrors
             }
         }
        case 'UPDATE_PAYOUT':
         return {
           ...state,
           payout: validatePayout
         }
         case 'ERROR_PAYOUT':
         return {
             ...state,
                 error: translateErrors
         }
        default:
          return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/bet.js